import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { AlertController, IonButton, IonIcon, NavController } from '@ionic/angular';

import { OneOnOneLanguage } from '@ninety/mobile/platform/api';
import { NavigationService } from '@ninety/mobile/platform/state';

@Component({
  selector: 'nty-discussion-unsaved-changes',
  imports: [IonButton, IonIcon],
  template: `
    <ion-button id="unsaved-changes-alert" class="terra-body" size="small" (click)="onBackClicked()">
      <ion-icon slot="start" name="chevron-back-outline" />
      Back to {{ lang.items }}
    </ion-button>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      @use 'terra';

      :host {
        display: inline-block;
      }

      ion-button {
        --background: transparent;
        --background-activated: transparent;
        --box-shadow: none;
        --padding-start: 0;

        &::part(native) {
          color: terra.color(text, light);
        }
      }
    `,
  ],
})
export class DiscussionUnsavedChangesComponent {
  @Input({ required: true }) lang!: OneOnOneLanguage;
  @Input({ required: true }) saved!: boolean;

  private nav = inject(NavigationService);
  private navCtrl = inject(NavController);
  private alertCtrl = inject(AlertController);

  async onBackClicked() {
    if (this.saved) {
      this.goBack();
    } else {
      const alert = await this.alertCtrl.create({
        header: 'Unsaved changes',
        message: 'Are you sure you want to leave without saving?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
          },
          {
            text: 'Continue without saving',
            role: 'confirm',
            handler: () => this.goBack(),
          },
        ],
      });

      await alert.present();
    }
  }

  goBack() {
    this.navCtrl.navigateBack(this.nav.getDiscussionsRoute());
  }
}
